<template>
  <div>
    <div class="pop_ul scrollBar" ref="pop_ul">
      <el-dropdown style="width: 100%" @command="sel" v-if="emails.length">
        <div class="email">
          <div class="img">
            <img src="@/assets/img/my_avatar.png" />
          </div>
          {{ email.target }}
          <img v-if="emails.length" src="@/assets/img/dow.png" class="dow" />
        </div>

        <el-dropdown-menu
          v-if="emails.length"
          :hide-timeout="1000"
          slot="dropdown"
        >
          <el-dropdown-item
            v-for="(item, index) in emails"
            :key="index"
            :command="{
              ...item,
            }"
          >
            <div class="email">
              <div class="img" style="display: inline-block">
                <img src="@/assets/img/my_avatar.png" />
              </div>
              {{ item.target }}
            </div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <div v-else style="height: 10px"></div>
      <div
        class="list"
        :style="{
          'min-height': height,
          position: 'relative',
          'padding-bottom': '77px',
        }"
      >
        <div class="source">
          <div class="source_left">
            <div class="source_name">{{ $t("email.title") }}</div>
            <el-select
              style="width: 150px; margin-left: 0"
              @change="getlist()"
              class="countrys"
              v-model="key.pkg"
            >
              <el-option :label="$t('All')" :value="0"></el-option>
              <el-option :label="$t('Samsung Email')" :value="1"></el-option>
              <el-option :label="$t('Gmail')" :value="2"></el-option>
              <el-option :label="$t('Outlook')" :value="3"></el-option>
            </el-select>
          </div>
          <div class="source_left">
            <div class="source_name">{{ $t("email.folder") }}</div>
            <el-select
              style="width: 150px; margin-left: 0"
              class="countrys"
              disabled
              :value="0"
            >
              <el-option :label="$t('Inbox')" :value="0"></el-option>
            </el-select>
          </div>
        </div>
        <div
          @click="gopop(val)"
          :class="val.id == pop.id ? 'pop_li mr' : 'pop_li'"
          v-for="(val, key) in list"
          :key="key"
        >
          <div class="pop_li_t">
            {{ val.from }}
            <span>{{ val.createtime }}</span>
          </div>
          <div class="pop_li_c">{{ val.subject }}</div>
        </div>
        <div class="pagination" v-if="code > 0">
          <el-pagination
            @current-change="setPage"
            background
            layout="prev, pager, next"
            :total="code"
          ></el-pagination>
        </div>
      </div>
    </div>
    <div
      id="dialog"
      :style="{ width: bodyWidth - 645 + 'px', height: bodyHeight - 60 + 'px' }"
    >
      <template v-if="pop.subject">
        <div class="name">{{ pop.subject }}</div>
        <div
          class="dialog scrollBar"
          :style="{ height: bodyHeight - 139 + 'px' }"
        >
          <div class="d_email">
            <div class="img">
              <img :src="pop.avata || require('@/assets/img/my_avatar.png')" />
            </div>
            <div>{{ pop.username }} &lt;{{ pop.from }}&gt;</div>
            <div class="d_email_time">
              <span>{{ pop.createtime }}</span>
            </div>
          </div>
          <div class="d_email_header">
            <div>
              <span>{{ $t("email.to") }}</span>
              {{ pop.target || "" }}
            </div>
            <div>
              <span>{{ $t("From:") }}</span>
              {{ pop.from }}
            </div>
            <div>
              <span>{{ $t("Subject:") }}</span>
              {{ pop.subject }}
            </div>
            <div>
              <span>{{ $t("Date:") }}</span>
              {{ pop.createtime }}
            </div>
          </div>
          <div class="Email_con" v-html="pop.content">
            <!-- <p>You're receiving this email because you requested a password reset for your EA Account. If you did not request this change, you can safely ignore this email.
        </p>
        <p>
        You can change your password again at any time from within your My Account portal at www.ea.com/.
        </p>
        <p>
        <b>Happy gaming, The EA Team</b>
            </p>-->
          </div>
        </div>
      </template>
      <template v-else-if="status">
        <div class="noData">{{ $t("email.no") }}</div>
      </template>
    </div>
  </div>
</template>

<script>
import { getEmailList, getEmailReceiver } from "@/api/user";
export default {
  name: "HelloWorld",
  data() {
    return {
      bodyHeight: document.body.clientHeight || window.innerHeight,
      bodyWidth: document.body.clientWidth || window.innerWidth,
      msg: "",
      key: {
        equipment_id: localStorage.getItem("systemId"),
        page: 1,
        receiver: "",
        limit: 10,
        pkg: 0,
        // starttime: '1900-09-10',
        // endtime: '2220-09-10'
      },
      list: [],
      emails: [],
      pop: {
        id: 0,
        target: "",
        from: "",
        createtime: "",
        username: "",
        content: "",
      },
      code: 0,
      email: {},
      height: null,
      status: false,
    };
  },
  mounted() {
    this.status = false;
    getEmailReceiver({
      equipment_id: localStorage.getItem("systemId"),
    }).then((res) => {
      if (res.code !== 1) {
        return;
      }
      if (res.data.length > 0) {
        this.email = res.data[0];
        this.emails = res.data;
        this.key.receiver = this.email.target;
        this.getlist();
      } else {
        this.status = true;
      }
    });
  },
  methods: {
    sel(item) {
      console.log(item);
      this.email = item;
      this.key.receiver = this.email.target;
      this.getlist();
    },
    setPage(e) {
      this.key.page = e;
      this.getlist();
    },
    getlist() {
      this.status = false;
      getEmailList(this.key).then((adj) => {
        this.code = adj.data.count;
        this.list = adj.data.list;
        if (this.list.length > 0) {
          this.gopop(this.list[0]);
        } else {
          this.gopop({});
        }
        this.$nextTick(() => {
          this.height = `calc(${this.$refs.pop_ul.clientHeight}px - 79px  - 78px)`;
        });
        this.status = true;
      });
    },
    gopop(adj) {
      this.pop = adj;
      this.pop.content = adj.content.replace(/\n/g, "<br>");
    },
    getlists(a) {
      if (a) {
        this.key.page = a;
      }
      this.list = [];
      this.getlist();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/deep/.el-dropdown-menu {
  background: #f6f8fa;
  min-width: 200px;
  left: 389px !important;
}
/deep/.el-dropdown-menu__item {
  height: 44px;
  line-height: 44px;
  padding: 0;
}
.pop_ul {
  float: left;
  /* width: 385px; */
  width: 386px;
  border-right: 1px solid #e1e3e6;
  background: #fff;
  overflow: hidden;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  overflow: auto;
}
.email {
  background: #f6f8fa;
  width: 100%;
  height: 44px;
  line-height: 44px;
  font-size: 13px;
  color: #45484d;
  overflow: hidden;
  word-break: keep-all;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.email:hover {
  background: rgba(0, 238, 195, 0.1);
}
.email .img {
  float: left;
  width: 24px;
  height: 24px;
  margin: 10px 10px 0 30px;
  border-radius: 50%;
  overflow: hidden;
}
.email .img img {
  width: 24px;
  height: 24px;
  display: block;
}
.email .dow {
  display: block;
  float: right;
  width: 16px;
  height: 16px;
  margin: 14px 20px 0 0;
  cursor: pointer;
}
.source {
  width: 100%;
  height: auto;
  border-bottom: 0 solid #e1e3e6;
  overflow: hidden;
  display: flex;
  align-items: flex-end;
  min-height: 77px;
}
.source_left {
  float: left;
  width: 150px;
  height: auto;
  padding-left: 30px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 65px;
}
.el-dropdown-menu__item .email {
  margin-right: 10px;
}
.el-dropdown-menu__item .email .img {
  margin: 10px 10px 0 10px;
}
.source_left .source_name {
  font-size: 13px;
  color: #45484d;
  /* line-height: 30px; */
  /* margin-top: 15px; */
}
.source_input {
  width: 148px;
  height: 36px;
  background: #f6f8fa;
  border: 1px solid #d5d7db;
  border-radius: 8px;
  line-height: 36px;
  text-indent: 10px;
  font-size: 13px;
}
.source_input .dow {
  display: block;
  float: right;
  width: 16px;
  height: 16px;
  margin: 10px 10px 0 0;
  cursor: pointer;
}
.pop_li {
  width: 323px;
  padding: 20px 30px;
  margin: 0;
  border-bottom: 1px solid #e1e3e6;
}
.pop_li.mr {
  background: rgba(0, 238, 195, 0.1);
}
.pop_li_t {
  font-size: 14px;
  line-height: 20px;
  color: #000927;
  font-weight: 700;
  overflow: hidden;
  margin-bottom: 10px;
}
.pop_li_t span {
  font-size: 12px;
  line-height: 20px;
  color: #9f9f9f;
  font-weight: 400;
  float: right;
}
.pop_li_c {
  font-size: 13px;
  line-height: 20px;
  color: #45484d;
}
.mes_a {
  margin: 20px auto;
  overflow: hidden;
}
.mes_a a {
  float: left;
  display: block;
  width: 32px;
  height: 32px;
  border: 1px solid #9f9f9f;
  border-radius: 6px;
  margin-left: 8px;
  color: #9f9f9f;
  font-size: 13px;
  line-height: 32px;
  text-align: center;
}
.mes_a a:first-child {
  margin-left: 0;
}
.mes_a a.mr {
  background: #00eec3;
  color: #000927;
  border-color: #00eec3;
}
.mes_a a img {
  display: block;
  width: 16px;
  height: 16px;
  margin: 8px;
}
#dialog {
  position: absolute;
  /* top: 60px; */
  right: 0;
  background: #fff;
  border-left: 1px solid #e1e3e6;
}
#dialog .name {
  width: 100%;
  height: 77px;
  line-height: 77px;
  border-bottom: 1px solid #e1e3e6;
  font-size: 16px;
  color: #000927;
  font-weight: 700;
  text-indent: 40px;
}
#dialog .dialog {
  width: 100%;
  overflow: auto;
}
#dialog .user {
  overflow: hidden;
  margin-top: 20px;
}
#dialog .user_img {
  float: left;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  overflow: hidden;
  margin-left: 40px;
}
#dialog .user_img img {
  float: left;
  width: 40px;
  height: 40px;
  display: block;
}
#dialog .user_name {
  float: left;
  overflow: hidden;
  margin-left: 10px;
}
#dialog .user_tit {
  font-size: 14px;
  color: #000927;
  font-weight: 700;
}
#dialog .user_time {
  font-size: 11px;
  color: #9f9f9f;
}
.d_email {
  overflow: hidden;
  margin-top: 30px;
  margin-left: 3.75%;
}
.d_email .img {
  float: left;
  width: 32px;
  height: 32px;
  margin: 0 10px 0 0;
  border-radius: 50%;
  overflow: hidden;
}
.d_email .img img {
  width: 32px;
  height: 32px;
  display: block;
}
.d_email div {
  line-height: 16px;
  font-size: 12px;
  color: #45484d;
}
.d_email div.d_email_time {
  font-size: 12px;
  color: #9f9f9f;
}
.d_email div.d_email_time img {
  float: left;
  display: block;
  width: 16px;
  height: 16px;
  cursor: pointer;
}
.d_email div.d_email_time span {
  float: left;
}
.d_email_header {
  width: 92.5%;
  margin: 15px auto;
  background: #f1f3f5;
  border-radius: 12px;
  font-size: 13px;
  padding: 15px 0;
  line-height: 30px;
  color: grey;
}
.d_email_header div span {
  display: block;
  float: left;
  width: 60px;
  color: #000927;
  margin-left: 15px;
}
.Email_con {
  font-size: 14px;
  line-height: 20px;
  overflow: hidden;
  width: 92.5%;
  margin: 15px auto;
}
.countrys {
  height: 36px;
}
</style>



// WEBPACK FOOTER //
// src/components/Email.vue